import { SystemActionLogsTypeEnum, useGetSystemActionCountQuery } from "gql/generated.graphql";
import DashboardWidgetContainer from "../DashboardWidgetContainer/DashboardWidgetContainer";
import { useTheme } from "styled-components";
import { useTranslation } from "react-i18next";
import { useCallback, useContext, useMemo } from "react";
import { DatePeriodTypesEnum, FilterContext, getPeriodRangeByPeriodType } from "dash-ui";


const DashboardWidgetPropertyMediakit = () => {
  const theme = useTheme();
  const { t } = useTranslation('pages');
  const { state: filterState } = useContext(FilterContext);
  const propertyId = filterState?.propertyId;

  const { data: dataPeriod, loading: loadingPeriod } =
    useGetSystemActionCountQuery({
      variables: {
        filter: {
          propertyId: filterState?.propertyId,
          type: SystemActionLogsTypeEnum.MediaDownloaded,
          dateRange: filterState.dateRange
          ? {
              startDate: filterState.dateRange?.startDate,
              endDate: filterState.dateRange?.endDate,
            }
          : getPeriodRangeByPeriodType(DatePeriodTypesEnum.CURRENT_WEEK),
        },
      },
      skip: propertyId === '' || propertyId === undefined,
    });

  const { countPeriod } = useMemo(
    () => ({
      countPeriod: dataPeriod?.getSystemActionCount || 0,
    }),
    [dataPeriod]
  );

  const { data, loading } =
  useGetSystemActionCountQuery({
      variables: {
        filter: {
          propertyId: filterState?.propertyId,
          type: SystemActionLogsTypeEnum.MediaDownloaded,
        },
      },
      skip: propertyId === '' || propertyId === undefined,
    });

  const { count } = useMemo(
    () => ({
      count: data?.getSystemActionCount || 0,
    }),
    [data]
  );

  const { data: dataMediaKit, loading: loadingMediaKit } =
    useGetSystemActionCountQuery({
      variables: {
        filter: {
          propertyId: filterState?.propertyId,
          type: SystemActionLogsTypeEnum.MediaAddedToMediaKit,
          dateRange: filterState.dateRange
          ? {
              startDate: filterState.dateRange?.startDate,
              endDate: filterState.dateRange?.endDate,
            }
          : getPeriodRangeByPeriodType(DatePeriodTypesEnum.CURRENT_WEEK),
        },
      },
      skip: propertyId === '' || propertyId === undefined,
    });

  const { countMediaKit } = useMemo(
    () => ({
      countMediaKit: dataMediaKit?.getSystemActionCount || 0,
    }),
    [dataMediaKit]
  );

  const makePlaceholderText = useCallback(() => {
    if (count === 0) {
      return t('organizationDashboardPage.propertyMediaKitPlaceholderText') || '';
    }
    return t('organizationDashboardPage.propertyMediaKitPlaceholderTextPeriod') || '';
  }, [count, t])

  return (
    <DashboardWidgetContainer
      bgColor={theme.colors.g20}
      icon="mediaFolderPlaceholder"
      placeholderTitle={
        t('organizationDashboardPage.mediaKitWidgetPlaceholderTitle') || ''
      }
      placeholderText={makePlaceholderText()}
      mediaKit
      count={countPeriod}
      countMediaKit={countMediaKit}
      loading={loadingPeriod && loading && loadingMediaKit}
    />
  )
}

export default DashboardWidgetPropertyMediakit;
